// src/utils/axios.js
import axios from "axios";
import { API_BASE_URL } from "../config";

const axiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api`, // 👈 tutte le chiamate saranno relative a /api
  // withCredentials: true, // abilita solo se usi cookie cross-domain
  timeout: 30000, // opzionale
});

// (opzionale) intercettore richiesta per logging o header comuni
axiosInstance.interceptors.request.use(
  (config) => {
    // Esempio: header standard
    // config.headers["X-Requested-With"] = "XMLHttpRequest";
    return config;
  },
  (error) => Promise.reject(error)
);

// tuo intercettore di risposta
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error?.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
